import { CoKitchenType } from 'models/cokitchen.model';
import { StoreType } from 'models/store.model';
import { TransferRequestType } from 'models/transfer-request.model';
import { createContext, Dispatch, SetStateAction, useContext } from 'react';

export type TransferDetailsType = {
  cokitchen: CoKitchenType;
  store: StoreType;
  title: string;
  note: string;
  storeType: { name: string; id: string };
};
export type TransferContextType = {
  procurementToUpdate: TransferRequestType;
  setProcurementToUpdate: Dispatch<SetStateAction<TransferRequestType>>;
  transferDetails: TransferDetailsType;
  setTransferDetails: (arg0: TransferDetailsType) => void;
  isUpdateProcurementDisabled: boolean;
  setIsUpdateProcurementDisabled: (arg0: boolean) => void;
};

export const TransferContext = createContext({} as TransferContextType);
const useTransferContext = () => {
  const context = useContext(TransferContext);
  return context;
};

export default useTransferContext;
